/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_NotesInputs */

const en_form_notes = /** @type {(inputs: Form_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

const he_form_notes = /** @type {(inputs: Form_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הערות`)
};

/**
* | output |
* | --- |
* | "Notes" |
*
* @param {Form_NotesInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_notes = /** @type {((inputs?: Form_NotesInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_NotesInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_notes(inputs)
	return he_form_notes(inputs)
});